import { gtmPNCart } from './Reducers/PNGtmEnhancedEcom.reducer';

export const pnGtmEnhancedEcom = {
    gtmPNCart
};